module.exports = __webpack_public_path__ + "img/enigma-reflect.846c55ef.jpg";